import React from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import Tabs, { Tablist } from "../../components/ui/Tabs/Tabs";
import Modal from "../../components/ui/Modal/Modal";
import { SaveIcon } from "../../assets/icons";

//! Components
import FilterExchange from "./Section/OrderExchange/Section/OrderExchangeFilter";
import Table from "./Components/Table";
import { Pagination } from "../../components/ui/Table/Pagination/Pagination";
import FilterRefund from "./Section/OrderCancellation/Section/OrderCancellationInfo";
import { OrderStatus } from "./Section/OrderStatus/OrderStatus";
import { OrderCancellation } from "./Section/OrderCancellation/OrderCancellation";
import { OrderExchange } from "./Section/OrderExchange/OrderExchange";
import { OrderReturned } from "./Section/OrderReturned/OrderReturned";

const tabs = [
  {
    title: "주문 현황",
    id: 1,
  },
  {
    title: "주문 취소",
    id: 2,
  },
  {
    title: "교환",
    id: 3,
  },
  {
    title: "반품",
    id: 4,
  },
];

const OrderManagementPage = () => {
  const [currentTab, setCurrentTab] = React.useState(1);
  const onChangeTab = (id) => {
    setCurrentTab(id);
  };

  return (
    <div>
      <TitlePage title="주문내역 관리" />
      <Tabs
        tabWidth="w-20"
        onChangeTab={onChangeTab}
        currentTab={currentTab}
        tabs={tabs}
      >
        <Tablist currentTab={currentTab} index={1}>
          <OrderStatus />
        </Tablist>
        <Tablist currentTab={currentTab} index={2}>
          <OrderCancellation />
        </Tablist>
        <Tablist currentTab={currentTab} index={3}>
          <OrderExchange />
        </Tablist>
        <Tablist currentTab={currentTab} index={4}>
          <OrderReturned />
        </Tablist>
      </Tabs>
    </div>
  );
};

export default OrderManagementPage;
